import type { ApiEventImportedType } from '#/modules/listing/events/api/types/ApiEventImportedType';

export const EVENT_IMPORTED_TYPE_MAP: Record<ApiEventImportedType, string> = {
  NYCPARKS: 'NYC Parks',
};
